import { render } from "./SaveModalMain.vue?vue&type=template&id=32bb1fd6&scoped=true"
import script from "./SaveModalMain.vue?vue&type=script&lang=js"
export * from "./SaveModalMain.vue?vue&type=script&lang=js"

import "./SaveModalMain.vue?vue&type=style&index=0&id=32bb1fd6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bb1fd6"]])

export default __exports__